import '../App.css';
import React from 'react';
import { auth } from '../firebase.js';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { updateParticipantData, logStartTest, logStartHighlighting, logStartTestEvent } from '../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme, Text, Heading, Image } from '@adobe/react-spectrum';
import uiButtons from '../misc-interfaces/images/ui-buttons.png';
import noSelection from '../misc-interfaces/images/no-selection.png';
import cursorSelection from '../misc-interfaces/images/cursor-highlight.png';
import selection from '../misc-interfaces/images/selection.png';
import highlight from '../misc-interfaces/images/highlight.png';
import deleteHighlight from '../misc-interfaces/images/delete.png';
import toolbar from '../misc-interfaces/images/toolbar.png';
import nudgingNoSelection from '../misc-interfaces/images/nudging-no-selection.png';
import nudgingHighlight from '../misc-interfaces/images/nudging-highlight.png';
import nudgingCircle from '../misc-interfaces/images/nudging-circle.png';
import nudgingTimeWait from '../misc-interfaces/images/nudging-time-wait.png';
import nudgingTimeRelease from '../misc-interfaces/images/nudging-time-release.png';
import nudgingRedact from '../misc-interfaces/images/nudging-redact.png';
import nudgingTooltip from '../misc-interfaces/images/nudging-tooltip.png';

function NudgingInstructions({ currentIndex, workerId, participantId, stage, experiment, condition, callbacks }) {
    function submitForm(e) {
        e.preventDefault();
        if (stage === "highlight") {
            let event = {
                highlightStartTime: Date.now(),
                workerId: workerId,
                participantId: participantId,
                experiment: experiment,
                condition: condition,
                currentIndex: currentIndex,
            }
            logStartHighlighting(event, callbacks);
        }

        else if (stage === "test") {
            if (experiment === "exp3-withinHighlights") {
                let event = {
                    testStartTime: Date.now(),
                    workerId: workerId,
                    participantId: participantId,
                    experiment: experiment,
                    condition: condition,
                    currentIndex: currentIndex,
                }
                logStartTestEvent(event, callbacks);
            }
            else {
                logStartTest(participantId, callbacks);
            }
        }
    }

    return (
        <>
            <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>
                    <div id="textToRead" className='documentReader'>
                        <Heading level={1} width="100%" marginBottom="size-100" marginTop="size-0">Instructions</Heading>

                        {stage === "highlight" ?
                            <>


                                {currentIndex === 0 ?
                                    <>
                                        <Text>In this experiment, you will be asked to (1) read two short documents and (2) answer questions about them. Make sure you have a stable internet connection.</Text>

                                        <br /><br />
                                    </>
                                    : <><Text>As a reminder, in this experiment, you will (1) read two short documents and (2) answer questions about them. Make sure you have a stable internet connection. <b>This is the second document you will be reading.</b></Text><br /><br /></>
                                }

                                {experiment === 'exp3-withinHighlights' ?

                                    <Text>While reading the document, you will be asked to highlight parts of the document that you think are important to help you study for the upcoming test. <b>The test will consist of 20 multiple choice questions and you will have 5 minutes to complete it. This is an open-book test, so you will have access to the document and your highlights as you answer the questions.</b></Text>

                                    : <Text>While reading the document, you will be asked to highlight parts of the document that you think are important to help you study for the upcoming test. <b>The test will consist of 5 questions and you will have 1.5 minutes (1:30) to complete it. This is an open-book test, so you will have access to the document and your highlights as you answer the questions.</b></Text>

                                }
                                {currentIndex === 0 ? <><br /><br /><mark>Note that this is part 1 of the experiment. If you've already participated in part 1 (reading) yesterday, please contact the experiment facilitator so you can be moved to part 2 (test).</mark></>
                                    : null}
                                <br /><br />
                                <Text><b>Do not take any notes or screenshots of the document or its contents, do not look up the document online, and do not use the "reader" feature of your browser.</b></Text>
                                <>
                                    <br />
                                    <br />
                                    <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-0">Creating a Highlight</Heading>
                                    {currentIndex === 0 ?
                                        <><Text>This is a simple highlighting tool, so you cannot adjust the colours. All highlights will appear yellow. There is also no "comment" functionality tied to highlights.</Text><br /><br /></>
                                        : null
                                    }


                                    {
                                        condition === "time" ?
                                            <>
                                                <Text>Drag your cursor over words you wish to highlight. You will notice a small gauge near your cursor. <b>To create a highlight, you must keep your mouse button down and stay still for some time to fill up the gauge.</b> If you do not wait long enough, the highlight will not be created, and if you move the cursor, the gauge will reset.</Text>
                                                <br /><br />

                                                <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                                    <Image src={nudgingNoSelection} width={'22%'} marginBottom={2} alignItems={"center"} alt=""></Image>
                                                    <Image src={nudgingTimeWait} width={'26%'} marginTop={2} alignItems={"center"} alt=""></Image>
                                                    <Image src={nudgingTimeRelease} width={'22%'} alignItems={"center"} alt=""></Image>
                                                    <Image src={nudgingHighlight} width={'22%'} alignItems={"center"} alt=""></Image>
                                                </Flex>

                                                <br /><br />

                                                <mark>The time spent waiting for the gauge to fill up is mapped to the number of words you have highlighted, and changes as you create and delete comments.</mark> <br /><br />
                                            </>
                                            : condition === "redact" ?
                                                <>
                                                    <Text>Drag your cursor over words you wish to highlight. <b>When the mouse button is down, the document text will become obscured (i.e., the text will have a darker background).</b> The highlight will be created when you lift your mouse and all obscuring will be reset.</Text>


                                                    <br /><br />
                                                    <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                                        <Image src={nudgingNoSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                                        <Image src={nudgingRedact} width={'25%'} alignItems={"center"} alt=""></Image>
                                                        <Image src={nudgingHighlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                                    </Flex>

                                                    <br /><br />

                                                    <mark>The background darkness of the text is mapped to the number of words you have highlighted, and changes as you create and delete comments.</mark> <br /><br />

                                                </>
                                                : condition === "trailing" ?
                                                    <>
                                                        <Text>Drag your cursor over words you wish to highlight. When your mouse button is down, a circle will appear. <b>You must keep your cursor within the circle the entire time while selecting to highlight text.</b> If your cursor leaves the circle, the highlight will not be created.</Text>

                                                        <br /><br />


                                                        <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                                            <Image src={nudgingNoSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                                            <Image src={nudgingCircle} width={'25%'} alignItems={"center"} alt=""></Image>
                                                            <Image src={nudgingHighlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                                        </Flex>

                                                        <br /><br />

                                                        <mark>The size of the circle is mapped to the number of words you have highlighted, and changes as you create and delete comments.</mark> <br /><br />

                                                    </>

                                                    : condition === "tooltip" ?

                                                        <>
                                                            <Text>Drag your cursor over words you wish to highlight. Highlights will be added automatically on mouse release. <b>You will notice a tooltip above your cursor as you select text.</b></Text>

                                                            <br /><br />
                                                            <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                                                <Image src={nudgingNoSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                                                <Image src={nudgingTooltip} width={'25%'} alignItems={"center"} alt=""></Image>
                                                                <Image src={nudgingHighlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                                            </Flex>
                                                            <br /><br />
                                                        </>

                                                        :

                                                        <>
                                                            <Text>Drag your cursor over words you wish to highlight. Highlights will be added automatically on mouse release. </Text>

                                                            <br /><br />
                                                            <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                                                <Image src={noSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                                                <Image src={selection} width={'25%'} alignItems={"center"} alt=""></Image>
                                                                <Image src={highlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                                            </Flex>
                                                            <br /><br />
                                                        </>
                                    }

                                    <Text>The text selection will snap to entire words (note that selecting text at the end of a line might select the first word of the next or previous line as well).</Text>
                                    <br /><br />
                                    <Text>If for some reason your highlights do not appear, try keeping your cursor closer to the text.</Text>

                                    <br /><br />

                                    <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-0">Deleting a Highlight</Heading>


                                    <Text>To delete a highlight, click on it, and then click on the black Delete button that appears.</Text>

                                    <Flex direction="row" justifyContent={'center'} alignItems={"center"} gap={'size-100'}>
                                        <Image src={highlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                        <Image src={deleteHighlight} width={'25%'} alignItems={"center"} alt=""></Image>
                                        <Image src={noSelection} width={'25%'} alignItems={"center"} alt=""></Image>
                                    </Flex>

                                    <br /><br />

                                </>
                                <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-0">Finishing Reading and Highlighting</Heading>
                                <Text>Once you finish, you can press the black Finish Reading button at the bottom right corner of the page. You will then be asked some questions about your experience.</Text><br /><br />

                                {currentIndex === 0 ?
                                    <Text>You may now begin the first part of the experiment by pressing the button below.</Text>
                                    : <Text>You may now begin reading the second document by pressing the button below.</Text>
                                }
                            </> :

                            experiment === "exp2-highlights" ?

                                <>

                                    <Text>Previously, you read and highlighted a short document in preparation for a reading comprehension test. Now, you will answer 5 multiple choice questions about the document. Make sure you have a stable internet connection.</Text>
                                    <br /><br />
                                    <Text>This is an open-book test, so you will have access to the document and your highlights as you answer the questions.</Text>
                                    <br /><br />
                                    <Text><b>You will have 1.5 minutes (1:30) to answer the questions.</b> After 1.5 minutes, the test will automatically end, so make sure you can do it in one sitting. If you finish before 1.5 minutes have passed, you can press the black Finish Test button. You will then be asked some questions about your experience.</Text><br /><br />
                                    <Text><b>Do not look up the document online, and do not use the "find & search" and "reader" features of your browser.</b></Text>
                                    <br /><br />
                                    <Text>You may now begin the second part of the experiment by pressing the button below.</Text>
                                </>

                                :

                                <>
                                    {currentIndex === 0 ?
                                        <>
                                            <Text>Previously, you read and highlighted two short documents in preparation for a reading comprehension test. Now, you will answer 20 multiple choice questions about each document (in random order). Make sure you have a stable internet connection.</Text>
                                            <br /><br />
                                            <Text>Both are open-book tests, so you will have access to the documents and your highlights as you answer the questions.</Text>
                                            <br /><br />
                                            <Text><b>For each test, you will have 5 minutes to answer the questions.</b> After 5 minutes, the test will automatically end, so make sure you can do them in one sitting. If you finish before 5 minutes have passed, you can press the black Finish Test button. You will then be asked some questions about your experience.</Text><br /><br />
                                        </>
                                        : <>
                                            <Text>You will now answer 20 multiple choice questions about <b>the second document</b>. Make sure you have a stable internet connection.</Text>
                                            <br /><br />
                                            <Text>Like before, this is an open-book test, so you will have access to the documents and your highlights as you answer the questions.</Text>
                                            <br /><br />
                                            <Text><b>You will have 5 minutes to answer the questions.</b> After 5 minutes, the test will automatically end, so make sure you can it in one sitting. If you finish before 5 minutes have passed, you can press the black Finish Test button. You will then be asked some questions about your experience.</Text><br /><br />

                                        </>
                                    }

                                    <Text><b>Do not look up the document online, and do not use the "find & search" and "reader" features of your browser.</b></Text>
                                    <br /><br />
                                    <mark>Remember that the top 25% of scores for each condition will receive a $3 CAD bonus!</mark>
                                    <br /><br />
                                    <Text>You may now begin the second part of the experiment by pressing the button below.</Text>
                                </>
                        }


                        <Form marginTop="size-200" onSubmit={e => submitForm(e)}>
                            <Button variant='primary' type="submit" style='fill'>Start {stage === "highlight" && currentIndex === 0 ? "Experiment" : stage === "highlight" ? "Reading" : "Test"}</Button>
                        </Form>
                    </div>
                </Flex>
            </Provider>
        </>
    );
}

export default NudgingInstructions;